import recommendationForm from "./recommendationForm"
export default recommendationForm;
